//use black text to contrast.
export const themeGrey = "#8C929B";
//darkest color, use white text.
export const themeOffBlack = "#333840";
//accent color, use black text.
export const themeTan = "#E8CAB1";
//accent color 2, use white text.
export const themeRed = "#662624";
//use black text on this color.
export const themeCloud = "#C4CFD1";
export const themeBrown = "#635148";
export const themePink = "#F26878";